import { apiClient } from './api'
import { ENDPOINTS } from '@/config/api.config'

export interface CourseFeedback {
  id: number
  userId: string
  courseId: number
  rating: number
  comment: string
  createdAt: string
  updatedAt: string
}

export interface CreateFeedbackRequest {
  courseId: number
  rating: number
  comment: string
}

export const feedbackService = {
  submitFeedback: async (data: CreateFeedbackRequest): Promise<CourseFeedback> => {
    return apiClient.post<CourseFeedback>(ENDPOINTS.feedback.submit, data)
  },

  getMyFeedback: async (courseId: number): Promise<CourseFeedback | null> => {
    return apiClient.get<CourseFeedback | null>(ENDPOINTS.feedback.mine(courseId))
  },
}
